import { render } from "./edit-customer.vue?vue&type=template&id=65919216&scoped=true"
import script from "./edit-customer.vue?vue&type=script&lang=js"
export * from "./edit-customer.vue?vue&type=script&lang=js"

import "./edit-customer.vue?vue&type=style&index=0&id=65919216&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65919216"]])

export default __exports__